import nicheLoadingAnimation from 'assets/images/gif/nicheLoadingAnimation.gif'
import { T } from 'lib/tolgee'

import { translations } from './pending-niche.i18n'
import type { IPendingNiche } from './pending-niche.types'
import './pending-niche.styles.scss'

export const PendingNicheView = ({ isSevenDays }: IPendingNiche) => {
  return (
    <div className="PendingNiche">
      <img src={nicheLoadingAnimation} alt="Loading" width={296} height={296} />
      <div className="Text-wrapper">
        <p>
          <T keyName={translations.loadingTitle.key}>{translations.loadingTitle.defaultValue}</T>
        </p>
        <span>
          {isSevenDays ? (
            <T keyName={translations.loadingTextSevenDays.key}>{translations.loadingTextSevenDays.defaultValue}</T>
          ) : (
            <T keyName={translations.loadingText.key}>{translations.loadingText.defaultValue}</T>
          )}
        </span>
      </div>
    </div>
  )
}
